import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Bootstrap
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

// FontAwesome
import { library, IconPack } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(
  fas as IconPack,
  far as IconPack,
  fab as IconPack
)

// createApp(App).use(store).use(router).mount('#app')
createApp(App)
  .component('FontAwesomeIcon', FontAwesomeIcon)
  .use(router)
  .use(store)
  .mount('#app')
